import ko from 'knockout';
import viewModel from './app-shell.vm';
import templateMarkup from 'raw-loader!./app-shell.template.html';
    
    // this component is directly registered at 'src/app/component-registration.js'
    // since it is needed long before its parent module is loaded
    export default { synchronous: true, template: templateMarkup, viewModel: viewModel };

